export enum ApiTypes {
    None = 0,
    Api = 1,
    Background = 2
}